import * as swcHelpers from '@swc/helpers';
import { GET_BOOK_APPOINTMENT_TRY_IN_STORE_PRODUCTS } from '../queries/get-book-appointment-try-in-store-products.js';

const getBookAppointmentTryInStoreProducts = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apolloClient, skus, locale) {
        try {
            const { data , error  } = yield apolloClient.query(swcHelpers.objectSpread({
                query: GET_BOOK_APPOINTMENT_TRY_IN_STORE_PRODUCTS,
                variables: {
                    skus
                }
            }, locale ? {
                context: {
                    forwardHeaders: {
                        'Accept-Language': locale
                    }
                }
            } : {}));
            const productsQueryData = data.getProductsBySKUs;
            const productsData = productsQueryData.flatMap((product)=>{
                return product.variants.map((variant)=>{
                    var ref, ref1, ref2, ref3, ref4, ref5;
                    const image = variant.media.images[0];
                    return {
                        __itemType: 'product',
                        name: product.name,
                        slug: product.slug,
                        price: {
                            amount: ((ref = variant.prices.discountedPrice) === null || ref === void 0 ? void 0 : (ref1 = ref.price) === null || ref1 === void 0 ? void 0 : ref1.amount) || ((ref2 = variant.prices.originalPrice) === null || ref2 === void 0 ? void 0 : ref2.amount),
                            currencyCode: ((ref3 = variant.prices.discountedPrice) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.price) === null || ref4 === void 0 ? void 0 : ref4.currencyCode) || ((ref5 = variant.prices.originalPrice) === null || ref5 === void 0 ? void 0 : ref5.currencyCode)
                        },
                        image: {
                            url: image.url
                        }
                    };
                });
            });
            if (error) {
                console.error(error);
            }
            return productsData;
        } catch (error) {
            console.error(error);
            return undefined;
        }
    });
    return function getBookAppointmentTryInStoreProducts(apolloClient, skus, locale) {
        return _ref.apply(this, arguments);
    };
}();

export { getBookAppointmentTryInStoreProducts };
//# sourceMappingURL=book-appointment-try-in-store-products.js.map
